module.exports = new __parcel__URL__("darksuppression.34ff0728.png").toString();